require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./feature-music-on-my-mind.json") })
        }
      }, "path---feature-music-on-my-mind");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---feature-music-on-my-mind!./.cache/json/feature-music-on-my-mind.json
// module id = 644
// module chunks = 231608221292675